import axios from "../../../../axios";

import React, { useState } from "react";
import "./queryList.css";

const ResolveQuery = ({
  setQuery,
  queryId,
  setMarkQuery,
  setExpandQuery,
  setDataFinal,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isInProgress, setIsInProgress] = useState(false);
  let user_id = teacher_id;
  const handleMarkQuery = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.put(`/api/v1/query/updateStatus/${queryId}`, {
        user_id: user_id,
        updatedStatus: "resolved",
      });
      res &&
        setQuery((prevQuery) => {
          return prevQuery.map((query) => {
            if (query.id === queryId) {
              return { ...query, status: "resolved" };
            } else {
              return query;
            }
          });
        });
        setMarkQuery(false);
      setExpandQuery(false);
      setDataFinal({});
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
  };
  return (
    <div className=" delete_query_transprant_body ">
      <img
        src="/images/cross-circle3.svg"
        className=" delete_query_close_btn"
        alt=""
        onClick={(e) => setMarkQuery(false)}
      />
      <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_query_container shadow">
        <div className=" col-12 d-flex align-items-center justify-content-center flex-column text-center">
          <span className="mt-4 mb-5 delete_query_text">
            Are you sure you want to mark as resolve this Query?
          </span>
          <div className="col-12 p-0 gap-3 flex-wrap d-flex justify-content-center ">
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn"
              onClick={handleMarkQuery}
            >
              Yes
            </button>
            <button
              disabled={isInProgress}
              className="btn btn-danger col-sm-5 query_delete_btn default_deleteq_uery_no"
              autoFocus
              onClick={(e) => setMarkQuery(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResolveQuery;
